import StatusTag from '@innovyze/stylovyze/lib/components/StatusTag/StatusTag';
import { Menu, MenuItem } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import React, { useRef, useState } from 'react';
import * as Styled from './StatusTagSwitcher.styles';
/**
 * Status tag switcher
 */
export const StatusTagSwitcher = ({ statuses, defaultSelectedIndex, onChange, dataCy, buttonDataCy, }) => {
    const [selectedIndex, setSelectedIndex] = useState(defaultSelectedIndex ?? 0);
    const selected = statuses[selectedIndex];
    const [open, setOpen] = useState(false);
    const anchorEl = useRef(null);
    const handleClick = () => {
        setOpen(true);
    };
    const handleClose = (i) => () => {
        setOpen(false);
        setSelectedIndex(i);
        onChange?.(statuses[i]);
    };
    return (React.createElement(Styled.Wrapper, { ref: anchorEl, "data-cy": dataCy },
        React.createElement(Styled.SwitcherButton, { onClick: handleClick, "data-cy": buttonDataCy },
            React.createElement(StatusTag, { ...selected }),
            React.createElement(ExpandMore, null)),
        React.createElement(Menu, { anchorEl: anchorEl.current, open: open, onClose: () => setOpen(false) }, statuses.map(({ text, dataCy }, i) => i !== selectedIndex ? (React.createElement(MenuItem, { key: i, onClick: handleClose(i), "data-cy": dataCy }, text)) : null))));
};
StatusTagSwitcher.defaultProps = {};
export default StatusTagSwitcher;
